import {defineStore} from 'pinia'

export const useErrorStore = defineStore('error', {
  state: () => ({
    errors: [],
    maxErrors: 50,
  }),

  actions: {
    addError(error) {
      this.errors.unshift({
        id: Date.now() + Math.random(),
        ...error,
      })

      if (this.errors.length > this.maxErrors) {
        this.errors = this.errors.slice(0, this.maxErrors)
      }

      if (import.meta.env.DEV) {
        console.error('[Error Store]', error)
      }
    },

    clearErrors() {
      this.errors = []
    },

    removeError(id) {
      const index = this.errors.findIndex(e => e.id === id)
      if (index > -1) {
        this.errors.splice(index, 1)
      }
    },

    getErrorsByType(type) {
      return this.errors.filter(e => e.type === type)
    },

    getRecentErrors(count = 10) {
      return this.errors.slice(0, count)
    },
  },

  getters: {
    hasErrors: (state) => state.errors.length > 0,
    errorCount: (state) => state.errors.length,
  },
})
